import { render } from "./IntersectionObserver.vue?vue&type=template&id=60f72042&scoped=true"
import script from "./IntersectionObserver.vue?vue&type=script&lang=js"
export * from "./IntersectionObserver.vue?vue&type=script&lang=js"

import "./IntersectionObserver.vue?vue&type=style&index=0&id=60f72042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f72042"]])

export default __exports__